/* eslint-disable react/prop-types */
import cn from 'classnames';
import ReactGA from 'react-ga4';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { walletBalanceTopUp } from 'actions/trade';
import { getMixpanelPageName } from 'components/primaryHeader/partials/universalSearch/partials/helpers';
import { IS_DEMO, IS_INDIAN_EXCHANGE } from 'constants/constants';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { isUserIndianSelector, userSelector } from 'selectors/otherSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';
import DeltaButton from 'UIKit/DeltaButton/DeltaButton';

import styles from './index.module.scss';

function recordEvent(obj) {
  ReactGA.event(obj);
}

const DepositButton = ({
  title = 'Deposit',
  className,
  shouldRedirectToAddBank = false,
  isSubAccountHasSameEmail = false,
  toggleTransferFundModal,
}) => {
  const appDispatch = useAppDispatch();
  const history = useHistory();
  const user = useSelector(state => userSelector(state));
  const isUserIndian = useAppSelector(isUserIndianSelector);

  const onButtonClick = () => {
    recordEvent({
      category: 'User',
      action: 'deposit_button_clicked',
      value: user.id,
    });
    if (IS_INDIAN_EXCHANGE) {
      if (IS_DEMO) {
        return appDispatch(walletBalanceTopUp());
      }
      // If subaccount has the same email, toggle the transfer fund modal
      if (isSubAccountHasSameEmail) {
        return toggleTransferFundModal();
      }
      trackMixpanelEvent(
        shouldRedirectToAddBank
          ? MIXPANEL_EVENT_NAMES.ADD_BANK_ACCOUNT.ADD_BANK_DETAILS
          : MIXPANEL_EVENT_NAMES.DEPOSITS.ADD_FUND_CLICKED_HEADER,
        {
          source: 'Header',
          page_name: getMixpanelPageName(),
        }
      );
      return history.push(
        shouldRedirectToAddBank ? routes.account.bankDetails : routes.account.deposit
      );
    }
    if (isUserIndian) {
      trackMixpanelEvent(MIXPANEL_EVENT_NAMES.DEPOSITS.BUY_CRYPTO_CLICKED, {
        source: 'Header',
        page_name: getMixpanelPageName(),
      });

      return history.push(routes.account.buy_crypto);
    }

    trackMixpanelEvent(MIXPANEL_EVENT_NAMES.DEPOSITS.DEPOSIT_CLICKED_HEADER, {
      page_name: getMixpanelPageName(),
    });

    return history.push(routes.account.deposit);
  };

  return (
    <DeltaButton
      data-testid="depositButton"
      className={cn(styles[`deposit-button`], styles[className])}
      onClick={onButtonClick}
    >
      {title}
    </DeltaButton>
  );
};

export default DepositButton;
